module.exports = __webpack_public_path__ + "html/section-video-time_738e371e464d60f85a6e2dc269b638b5.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-video-time.html
// module id = Jul4
// module chunks = 78